import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';

import { parseHttpErrorBody } from '../../shared/forms/parse-http-error-body';
import {RequestParameters} from '../../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../../global';
import {UserClk} from './user-clk.model';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UsersClkService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getUsersClk (parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/operators/clk', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getUserClk (reference: string) {

    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/clk/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  postUserClk (userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.post(GlobalVariable.BASE_API_URL + '/operators/clk', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      )      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  putUserClk (userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.put(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      )      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  patchUserClk (userClk: UserClk) {

    const body = this.normalizeUserClkData(userClk);

    return this.http.patch(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      )      .catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  deleteUserClk (userClk: UserClk) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/operator/clk/' + userClk.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  disableUserClk(userClk: UserClk, stateToApply) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/operator/' + userClk.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  private normalizeUserClkData(userPartner: UserClk): UserClk {

    const body = Object.assign({}, userPartner);
    delete body.reference;

    if (body.picture !== null) {
      body.picture = body.picture.reference;
    }
    if (body.country !== null) {
      body.country = body.country.reference;
    }
    if (body.city !== null) {
      body.city = body.city.reference;
    }
    if (body.callCenter !== null) {
      body.callCenter = body.callCenter.reference;
    }
    if (body.role !== null) {
      body.role = body.role.reference;
    }
    if (body.platform !== null) {
      body.platform = body.platform.reference;
    }
    return body;
  }

  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/users/users-clk/users-clk.service.ts